<script setup lang="ts">
import { cn } from '@/lib/cn'

defineProps<{
  class?: string
}>()
</script>

<template>
  <div
    role="status"
    :class="cn('h-5 w-5 animate-spin rounded-full border-2 border-white/20 border-t-primary-400 motion-reduce:animate-none', $props.class)"
  />
  <span class="sr-only">Loading</span>
</template>
